import { TranslateService } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, input, model, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";

import { CustomerDescriptionService } from "../../../services/customer-description.service";
import { DialogMessageComponent } from "../../dialogs/dialog-message/dialog-message";

@Component({
  selector: "alias-editor",
  templateUrl: "alias-editor.component.html",
  styleUrls: ["alias-editor.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, FormsModule],
})
export class AliasEditorComponent {
  private readonly descriptionService = inject(CustomerDescriptionService);
  private readonly dialog = inject(MatDialog);
  private readonly translate = inject(TranslateService);

  readonly subscriptionId = input.required<string>();
  readonly customerDescription = model.required<string>();

  protected isEditable = signal(false);

  protected temporarySubscriptionName = signal("");

  startEditingCustomerDescription(event: Event) {
    this.cancelEvent(event);
    this.temporarySubscriptionName.set(this.customerDescription());
    this.isEditable.set(true);
  }

  cancelEvent(event: Event) {
    event.stopPropagation();
    event.preventDefault();
  }

  async saveCustomerDescription(event: Event) {
    this.cancelEvent(event);
    if (this.temporarySubscriptionName().length > 0) {
      this.isEditable.set(false);
      try {
        await this.descriptionService.save(this.subscriptionId(), this.temporarySubscriptionName());
        this.customerDescription.set(this.temporarySubscriptionName());
      } catch {
        this.dialog.open(DialogMessageComponent, {
          data: {
            title: this.translate.instant("Subscription.Message.AliasEditErrorTitle"),
            message: this.translate.instant("Subscription.Message.AliasEditErrorMessage"),
          },
        });
      }
    }
  }

  cancelEditingCustomerDescription(event: Event) {
    this.cancelEvent(event);
    this.isEditable.set(false);
  }
}
